import { IconButton, Stack } from '@mui/material';
import { EditFilled, CopyFilled, DeleteFilled } from '@ant-design/icons';

type ActionsColumnProps = {
    onEdit: () => void;
    onDuplicate: () => void;
    onDelete: () => void;
};

export const ActionsColumn = ({ onEdit, onDuplicate, onDelete }: ActionsColumnProps) => {
    return (
        <Stack direction="row">
            <IconButton onClick={onEdit}>
                <EditFilled />
            </IconButton>
            <IconButton onClick={onDuplicate}>
                <CopyFilled />
            </IconButton>
            <IconButton onClick={onDelete}>
                <DeleteFilled />
            </IconButton>
        </Stack>
    );
};
